import { DialogUI } from '../Interface';
import { useProjectTasks } from '../../hooks/useProjectTasks';
import { ProjectTaskPage } from './ProjectTaskPage';
import { Box } from '@mui/material';

const ProjectTaskDialog = ({
  open,
  handleClose,
  data = {},
  setFieldValue = () => {},
  disabledField = false,
  setTaskChanged = () => {},
  setSelectedValues = () => {},
}) => {
  const projectTasksState = useProjectTasks();

  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      headerContent="Projekt feladat"
      closeBtn={disabledField}
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '800px',
          },
        },
      }}
    >
      <Box py={2}>
        <ProjectTaskPage
          dialog={{
            handleClose,
            data,
            setFieldValue,
            disabledField,
            setTaskChanged,
            setSelectedValues,
          }}
          projectTasksState={projectTasksState}
        />
      </Box>
    </DialogUI>
  );
};

export default ProjectTaskDialog;
